import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import { selectEmailCard, selectTheme, set } from 'actions/template'
import { stepperIncrease } from 'actions/view'
import styles from './styles'
import * as themes from './themes/'
// import BackButton from './BackButton'

export default connect(
  state => ({
    templatesById: state.email.templatesById,
    sectionsLength: Boolean(state.email.sections.length),
    company_logo_url_color:
      state.data?.['account/preference']?.preferences?.company_logo_url_color,
    company_logo_url_whiteonblack:
      state.data?.['account/preference']?.preferences
        ?.company_logo_url_whiteonblack,
    company_logo_url_blackonwhite:
      state.data?.['account/preference']?.preferences
        ?.company_logo_blackonwhite,
    preferences: state.data?.['account/preference']?.preferences,
  }),
  dispatch =>
    bindActionCreators(
      { selectEmailCard, selectTheme, set, stepperIncrease },
      dispatch,
    ),
)(
  withStyles(styles)(
    ({
      selectTheme,
      selectEmailCard,
      classes,
      cols,
      taskForm,
      sectionsLength,
      set,
      stepperIncrease,
      company_logo_url_color,
      company_logo_url_blackonwhite,
      company_logo_url_whiteonblack,
      preferences,
    }) => (
      <div
        className={taskForm ? null : classes.themesList}
        // style={taskForm ? null : { paddingTop: 20 }}
      >
        {/* {taskForm ? null : <BackButton size="medium" text="Back" />} */}
        <GridList
          style={{ margin: '-12px' }}
          cellHeight={300}
          cols={cols}
          spacing={12}
        >
          {Object.values(themes).map(theme => (
            <GridListTile
              classes={{ tile: classes.tile }}
              className={classes.gridListTile}
              onClick={() => {
                if (sectionsLength) {
                  if (
                    window.confirm(
                      'This will replace all content currently in your editor. Are you sure?',
                    )
                  ) {
                    if (typeof theme === 'function') {
                      return Promise.resolve(
                        selectTheme(theme(preferences)),
                      ).then(() => {
                        selectEmailCard('blank')
                        stepperIncrease('task')
                        stepperIncrease('template')
                      })
                    }
                    return Promise.resolve(selectTheme(theme)).then(() => {
                      selectEmailCard('blank')
                      stepperIncrease('task')
                      stepperIncrease('template')
                    })
                    // if (theme && theme.value) {
                    //   set(theme.value)
                    // }
                  }
                } else {
                  if (typeof theme === 'function') {
                    return Promise.resolve(
                      selectTheme(theme(preferences)),
                    ).then(() => {
                      selectEmailCard('blank')
                      stepperIncrease('task')
                      stepperIncrease('template')
                    })
                  }
                  return Promise.resolve(selectTheme(theme)).then(() => {
                    selectEmailCard('blank')
                    stepperIncrease('task')
                    stepperIncrease('template')
                  })
                  // if (theme && theme.value) {
                  //   set(theme.value)
                  // }
                }
              }}
              key={`addOrEditTaskModalThemeGridListTile${theme.text}`}
            >
              <img
                src={
                  theme?.thumbnail ||
                  theme?.()?.thumbnail ||
                  'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
                }
                alt={theme?.text || theme?.()?.text}
                style={{ background: '#71bc37' }}
              />
              <GridListTileBar title={theme?.text || theme?.()?.text} />
            </GridListTile>
          ))}
        </GridList>
      </div>
    ),
  ),
)
